import RevxFlexLayout from 'components/RevxFlexLayout';
import { ConfigSvcProps } from '..';
import CommonJobSvcBorder from '../common/CommonJobSvcBorder';
import CommonJobSvcCotainer from '../common/CommonJobSvcCotainer';
import CommonJobSvcInstructions from '../common/CommonJobSvcInstructions';
import CommonJobSvcMessage from '../common/CommonJobSvcMessage';
import CommonJobSvcName from '../common/CommonJobSvcName';
import CommonJobSvcOption from '../common/CommonJobSvcOption';
import CommonJobSvcSpec from '../common/CommonJobSvcSpec';
import CommonQuantityPerBundle from '../common/CommonQuantityPerBundle';
import { useHideSvc } from '../hook/useHideSvc';
import { useHideSvcContainer } from '../hook/useHideSvcContainer';

const Fulfillment = (props: ConfigSvcProps) => {
  const hideSvc = useHideSvc(props);
  const hideSvcContainer = useHideSvcContainer(props);
  return (
    <>
      <div style={hideSvc}>
        <RevxFlexLayout align="top" justify="justify-start">
          <CommonJobSvcName {...props} />

          <div>
            <CommonJobSvcCotainer {...props}>
              <CommonJobSvcSpec {...props} disabled={hideSvcContainer} />
              <CommonJobSvcOption {...props} disabled={hideSvcContainer} />
              <CommonQuantityPerBundle {...props} disabled={hideSvcContainer} />
              <CommonJobSvcInstructions
                {...props}
                disabled={hideSvcContainer}
              />
              <CommonJobSvcMessage {...props} disabled={hideSvcContainer} />
            </CommonJobSvcCotainer>
          </div>
        </RevxFlexLayout>
        <CommonJobSvcBorder />
      </div>
    </>
  );
};

export default Fulfillment;
